/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { ITableInitialise } from '../../../../modules/table/types';

export const CampaignsTableAccountInitialise: ITableInitialise = {
    meta: {
        url: 'campaigns/account/meta',
    },
    list: {
        url: 'campaigns/account/list',
    },
    filterAndSort: {
        url: 'campaigns/account/filter-and-sort',
    },
    totalCount: {
        url: '/campaigns/account/totalCount',
    },
};

export const CampaignsTableSubscriberInitialise: ITableInitialise = {
    meta: {
        url: 'campaigns/subscriber/meta',
    },
    list: {
        url: 'campaigns/subscriber/list',
    },
    filterAndSort: {
        url: 'campaigns/subscriber/filter-and-sort',
    },
    totalCount: {
        url: '/campaigns/subscriber/totalCount',
    },
};
